/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { AdminTalentPoolCreateRequestColor } from './adminTalentPoolCreateRequestColor';
import type { AdminTalentPoolCreateRequestIcon } from './adminTalentPoolCreateRequestIcon';

export interface AdminTalentPoolCreateRequest {
  /**
     * @minLength 1
     * @maxLength 120
     */
  name: string;
  source: string;
  /** @pattern ^[a-z][a-z0-9_]{1,62}$ */
  index_alias: string;
  /** @maxItems 14 */
  disabled_filter_categories?: string[];
  icon?: AdminTalentPoolCreateRequestIcon;
  color?: AdminTalentPoolCreateRequestColor;
}
